export default __webpack_public_path__ + "static/CharacterSheetsProff-66eb7d6829c60f4f3f4b5a07b7e2480d.jpg";